// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ProjectVerificationCategory {
  W = 0,
  T = 1,
  S = 2,
}
